import styled from '@emotion/styled';
import { Button } from '@lightspeed/flame/Button';
import { themeGet } from '@lightspeed/flame/Core';

interface ButtonProps {
  color?: string;
  underline?: boolean;
  fontSize?: string;
  slim?: boolean;
}

export const TextLinkButton = styled(Button)<ButtonProps>`
  padding: 0;
  min-height: auto;
  background: none;
  outline: none;
  border: none;
  box-shadow: none;
  color: ${props => props.color || 'inherit'};
  margin-left: 0px !important;
  font-weight: ${props =>
    props.slim ? themeGet('fontWeights.regular') : themeGet('fontWeights.bold')};
  text-decoration: ${props => (props.underline ? 'underline' : 'none')};
  font-size: ${props => (props.fontSize ? props.fontSize : themeGet('fontSizes.text'))};
  &:focus,
  &:hover,
  &:active {
    background: none;
    outline: none;
    border: none;
    box-shadow: none;
  }
  &:hover {
    color: ${props => props.color || 'inherit'};
    text-decoration: ${props => (props.underline ? 'none' : 'underline')};
  }
`;
